import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { AccountBlock, SectionHeading } from '../Common';
import * as FormStructure from '../FormStructure';
import MarketingPreferencesFormContainer from '../MarketingPreferencesForm/MarketingPreferencesFormContainer';
import { ERROR_MESSAGE, LOADING_MESSAGE } from '../Messages/Messages';
import { MARKETING_PREFERENCES_FORM_BLOCK_QUERY } from './operations';

export default function MarketingPreferencesFormBlock({ hasProfileCompletionEnabled }) {
  const { loading, error, data } = useQuery(MARKETING_PREFERENCES_FORM_BLOCK_QUERY, {
    context: { batch: true },
  });

  if (loading) return LOADING_MESSAGE;
  if (error) return ERROR_MESSAGE;

  const {
    heading,
    subheading,
  } = data.textFor;

  const { email } = data.userInfo;

  const profileCompletionMarketingPreferencesBlock = () => (
    <>
      <FormStructure.FormWrapper>
        <FormStructure.FormGroup>
          <FormStructure.FormCell>
            <h2 className="h2" data-property={heading?.key}>{heading?.value}</h2>
          </FormStructure.FormCell>
          <p data-property={subheading?.key}>
            {subheading?.value}
          </p>
        </FormStructure.FormGroup>
      </FormStructure.FormWrapper>
      <MarketingPreferencesFormContainer email={email} hasProfileCompletionEnabled={hasProfileCompletionEnabled} />
    </>
  );

  return hasProfileCompletionEnabled ? (
    profileCompletionMarketingPreferencesBlock()
  ) : (
    <AccountBlock
      heading={(
        <SectionHeading>
          <h2 className="h3" data-property={heading?.key}>{heading?.value}</h2>
        </SectionHeading>
      )}
    >
      <MarketingPreferencesFormContainer email={email} />
    </AccountBlock>
  );
}

MarketingPreferencesFormBlock.propTypes = {
  hasProfileCompletionEnabled: PropTypes.bool,
};
MarketingPreferencesFormBlock.defaultProps = {
  hasProfileCompletionEnabled: false,
};
